module.exports = __webpack_public_path__ + "static/media/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.26.0e6c32ab.png";